import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { STORE_INFO } from '../constants';

export default function Contact() {
  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-800 mb-8">Connect With Us</h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-6">
            <h3 className="text-xl font-semibold mb-4">Contact Information</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <MapPin className="text-[#568203]" size={20} />
                <span>{STORE_INFO.address}</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="text-[#568203]" size={20} />
                <span>{STORE_INFO.phone}</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="text-[#568203]" size={20} />
                <span>{STORE_INFO.email}</span>
              </div>
            </div>
            <div className="pt-6">
              <h3 className="text-xl font-semibold mb-4">Follow Us</h3>
              <div className="flex gap-4">
                <a href="#" className="text-gray-600 hover:text-[#568203]">
                  <Facebook size={24} />
                </a>
                <a href="#" className="text-gray-600 hover:text-[#568203]">
                  <Instagram size={24} />
                </a>
                <a href="#" className="text-gray-600 hover:text-[#568203]">
                  <Twitter size={24} />
                </a>
              </div>
            </div>
          </div>
          <div>
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#568203] focus:border-[#568203]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#568203] focus:border-[#568203]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea
                  rows={4}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#568203] focus:border-[#568203]"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-[#568203] text-white py-2 px-4 rounded-md hover:bg-[#476c02] transition-colors"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}